import { Rocket } from 'lucide-react'
import { SiteLayout } from '../components/ui/site-chrome'
import { TrustPage } from '../components/ui/trust-page'

export default function ProductInnovationPage() {
  return (
    <SiteLayout
      current="/product-innovation"
      title="Product Innovation & AI Agent Pilots | Zadro"
      description="Product innovation pilots for companies that want custom AI software, browser extensions, agent orchestration, and SaaS product wedges."
    >
      <TrustPage
        Icon={Rocket}
        visual="innovation"
        eyebrow="Product Innovation"
        heroTitle="Turn custom software into a product wedge."
        heroCopy="Some engagements should become more than consulting artifacts. I help identify, design, and pilot custom software that can become internal leverage, customer-facing products, browser extensions, SaaS tools, or API/data layers."
        proof={[
          'Innovation track connects strategy, architecture, prototype, and commercialization.',
          'Deal Lab Pilot is the reference pattern for browser-extension-first agent products.',
          'Built for founder-led experiments that need technical taste and product discipline.',
        ]}
        cards={[
          {
            title: 'Deal Lab Pilot',
            copy: 'A Silo-style C-estimator for real estate investors: inspect multiple listing tabs, evaluate portfolio fit, and return green-light/red-light underwriting.',
          },
          {
            title: 'Agentic workflows',
            copy: 'Composable agents with canonical user systems, memory blocks, tools, and specialized outputs instead of one giant prompt.',
          },
          {
            title: 'SaaS path',
            copy: 'Prototype the wedge, validate the user behavior, then decide whether it becomes a standalone product, paid add-on, or internal platform.',
          },
        ]}
        sections={[
          {
            kicker: 'Deal Lab Example',
            title: 'The product thinks across ten open tabs.',
            copy: 'The investor opens property listings across Silo, Zillow, Redfin, LoopNet, or similar platforms. The extension reads each context, compares it to the investor profile, and ranks the deals.',
            items: [
              'Deal Underwriting Agent for DSCR, cap rate, CoC, IRR, rent, vacancy, and sensitivity',
              'Portfolio Risk Agent for exposure, debt, cash flow, concentration, and fit',
              'Document Diligence Agent for PDFs, rent rolls, T-12s, inspections, and reports',
              'SaaS dashboard for buy box, portfolio memory, stored deals, and exportable memos',
            ],
          },
          {
            kicker: 'Pilot Shape',
            title: 'A product innovation pilot has to prove behavior.',
            copy: 'The goal is not to build a giant platform first. The goal is to prove the daily workflow, the result quality, and the willingness to pay.',
            items: [
              'Define the narrow user, painful workflow, and decision moment',
              'Design schemas, context blocks, tools, and evaluation criteria',
              'Build a prototype that creates a visible wow moment',
              'Create the pricing, go-to-market, and next-build roadmap',
            ],
          },
        ]}
      />
    </SiteLayout>
  )
}
